import { styled } from 'styled-components';

import CarretRight from '@/shared/assets/caret-right.svg';

const BackIconImageWrapper = styled.div`
  position: absolute;
  left: 16px;
  top: 28px;
  display: flex;
  align-items: center;
  cursor: pointer;
  z-index: 1;
`;
const CarretRightIcon = styled(CarretRight)`
  display: flex;
  transform: rotate(180deg);
  height: 20px;
  width: 20px;
  path {
    stroke: #afafaf;
  }
`;

export { BackIconImageWrapper, CarretRightIcon };
